export default __webpack_public_path__ + "static/nfpa_b.5e6f5dfe82cf8438f3fd399eeea979c1.svg";